import html2canvas from 'html2canvas'

export async function getShareImageContents(element: HTMLElement) {
  const canvas = await html2canvas(element)

  return canvas.toDataURL()
}
